import {Box, Typography} from '@mui/material';
import YouTubeEmbed from '../YouTubeEmbed';

const HowToVideoTopic = () => {
  return (
    <Box>
      <Typography component='div'>
        <p>
          This video shows how to do a thing.
        </p>
      </Typography>

      <YouTubeEmbed videoId={'cBWRGXcNgnw'}/>
    </Box>
  );
};

export default HowToVideoTopic;